export default __webpack_public_path__ + "assets_logo_blue.7a061683.svg";